'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaBillingServiceProviderCtrl', function ($scope, $eaBackend, $eaConfig, $toolbar) {

    $scope.contact = $eaConfig.getConfiguration().svp.contact

    // Add Back Entry
    $toolbar.addItem('billing.upgradeEditions.Back', 'Back to Billing', 'fa-chevron-left', null, true, '/billing');
});
